import './Banner.scss';
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import requests from "../config/Requests";  
import axios from 'axios';
import QuickView from './QuickView';

function Banner() {
    const API_KEY = "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkNjBjNzQ5MWI1ODBiYTM5MTkxYmUxYmM1MTZkMmJlMiIsIm5iZiI6MTcxOTMxNzMxMS41ODI4NjksInN1YiI6IjY2N2FhZDk5ZDMxOTQ0ZDM3MDE1OTZhZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.FSfDtUpsYOy9O6iOozOgOM0PbmM_QJX9al_SxJdzI4w";

    const [movies, setMovies] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);
    const [popup, setPopup] = useState(false);

    function handleClickPopup() {
        setPopup(!popup);
    }

    useEffect(() => {
        async function fetchData() {
            try {
                const options = {
                    method: 'GET',
                    headers: {
                        accept: 'application/json',
                        Authorization: `Bearer ${API_KEY}`
                    }
                };
                const request = await axios.get(requests.fetchTrending, options);
                setMovies(request.data.results.slice(0, 5)); // On garde 5 films pour le carousel
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, []);

    // Carousel automatique avec fade
    
    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setCurrentIndex(prev => (prev + 1) % movies.length);
                setFade(true);
            }, 1000);
        }, 10000); // changement toutes les 6s
        return () => clearInterval(interval);
    }, [movies]);
    

    const currentMovie = movies[currentIndex];

    return (
        <header className={`banner ${fade ? "fade-in" : "fade-out"}`} 
            style={{ 
                "--banner-bg": `url("https://image.tmdb.org/t/p/original/${currentMovie?.backdrop_path}")`
            }}
        >
            <div className='banner__content'>
                <h1 className='banner__title'>{currentMovie?.title || currentMovie?.name || currentMovie?.original_name}</h1>
                <p className='banner__description'>
                    {currentMovie?.overview?.length > 100
                        ? currentMovie.overview.substr(0, 100) + "..."
                        : currentMovie?.overview || "No description"}
                </p>
                <div className='banner__buttons'>
                    <Link to={`/video/${currentMovie?.id}`}> 
                        <button className='banner__button banner__button--play'>
                            <PlayArrowIcon /> Lecture
                        </button>
                    </Link>
                    <button className='banner__button' onClick={handleClickPopup}>
                        <HelpOutlineIcon /> Plus d'infos
                    </button>
                </div>
            </div>
            <QuickView 
                bannerStyle={{}}
                movie={currentMovie}
                popup={handleClickPopup}
                popupStatut={popup} 
            />
        </header>
    );
}

export default Banner;
